import React, { useMemo, useState } from 'react';
import {Link, useNavigation} from 'react-navi';
import {EntryCard, NavBar} from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function RizeFinal() {
  let navigation = useNavigation();
  return (
    <div>
      <Helmet>
        <meta
          content={`ファイナル 特別協賛審査 詳細決定 | ${process.env.REACT_APP_WEBSITE_NAME}`}
          property="og:title"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-11-29`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-11-29`} aria-current="page">
                  ファイナル 特別協賛審査 詳細決定
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-small">
          <div className="content is-margin-bottom-3" style={{ lineHeight: 2 }}>
            <h3>ファイナル 特別協賛審査 詳細決定</h3>
            <p style={{ wordBreak: 'break-all' }}>
              この度、ファイナル期間「特別協賛審査」として
              <br />
              特別協賛の医療脱毛専門の「リゼクリニック・メンズリゼ」様（
              <a className="has-text-primary" href="https://www.rizeclinic.com/missmrcampus2019/" target="_blank">
                https://www.rizeclinic.com/missmrcampus2019/
              </a>
              ) とのコラボ企画を開催致します。
            </p>
            <p>
              ファイナリストによる“リゼダンス“をハロウィンコーデ動画・私服コーデ動画の計2回、ハッシュタグとともにツイートされ、そのツイートのRT数を競い合います。
              <br />
            </p>
            <p>
              セミファイナル実施「リゼクリニックの日」ファイナル実施「リゼハロウィン」「リゼウォーク」の３つの企画で獲得したRT数のトータルで最もRT数が多かった1名に「リゼウォーク賞」を贈呈いたします。
              <br />
              受賞者は11月11日当サイトにて発表いたします。
            </p>
            <p>※ 不正と思われるRT数は対象外と致します。</p>
            <div>
              <table className="table">
                <tbody>
                  <tr>
                    <th>期間</th>
                  </tr>
                  <tr>
                    <td>
                      10月29日(火)19:00～11月10日(日)21:59(ハロウィンコーデ）
                      <br />
                      11月7日(木)12:00～11月10日(日)21:59（私服コーデ）
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
          </div>
          <p className="title is-size-5 has-text-centered">「リゼウォーク賞」受賞者発表！</p>
          <div>
            <div className="columns is-variable is-multiline is-mobile is-mobile-2 is-margin-bottom-4 is-centered">
              <div className="column is-one-third-desktop is-one-third-tablet is-half-mobile">
                <EntryCard
                    onClick={async () => {
                      navigation.navigate(`/profile/${112}`);
                    }}
                    lazy
                    entryNumber={112}
                    name={'斎藤渚'}
                    college={'中央大学'}
                    twitter={'mscircle19_112'}
                    instagram={'nagi3_0516'}
                />
              </div>
            </div>
          </div>
          <p>
            詳細は以下サイトをご覧くださいませ。
            <br />
            <a
              className="has-text-primary"
              href="https://www.rizeclinic.com/missmrcampus2019/4thproject/"
              target="_blank"
            >
              https://www.rizeclinic.com/missmrcampus2019/4thproject/
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

export default RizeFinal;
